import Data from '../Api/Data'
import PrimaryKey from '../Api/PrimaryKey'
import { Type } from 'class-transformer'
import TCode6DocumentDM from './TCode6DocumentDM'
import TCode5DocumentDM from './TCode5DocumentDM'
import TCode4DocumentDM from './TCode4DocumentDM'
import TCode3DocumentDM from './TCode3DocumentDM'
import WarrantyB from './WarrantyB'
import TBatchDM from './TBatchDM'
import TRequestedBatchParameterHeaderDM from './TRequestedBatchParameterHeaderDM'
import TDeviceDocumentDM from './TDeviceDocumentDM'
import TPriceGroupDM from './TPriceGroupDM'
import TRoutingVariantDM from './TRoutingVariantDM'
import TMarketingPhaseDM from './TMarketingPhaseDM'
import TVATRateDM from './TVATRateDM'
import TArticleCodeDocumentDM from './TArticleCodeDocumentDM'
import TOfficerDocumentDM from './TOfficerDocumentDM'
import TCode2DocumentDM from './TCode2DocumentDM'
import TCode1DocumentDM from './TCode1DocumentDM'
import TContractCodeDocumentDM from './TContractCodeDocumentDM'
import TCostCentreCollectionDocumentDM from './TCostCentreCollectionDocumentDM'
import TQuotationRequestedItemDM from './TQuotationRequestedItemDM'
import QuotationOfrItemStat from './QuotationOfrItemStat'
import TArticleDM from './TArticleDM'
import MrktngDocItemGroup from './MrktngDocItemGroup'
import TQuotationDM from './TQuotationDM'
import TMeasureUnitDM from './TMeasureUnitDM'
import AlternativeUnit from './AlternativeUnit'
import TReqForQuoRequestedItemAloneDM from './TReqForQuoRequestedItemAloneDM'
import TReqForQuoOfferedItemAloneDM from './TReqForQuoOfferedItemAloneDM'
import TPriceListCalculationDM from './TPriceListCalculationDM'
import TProductCostingDM from './TProductCostingDM'

export default class TQuotationOfferedItemDM extends Data {
	public static className = 'TQuotationOfferedItemDM'
	public static primaryKey = 'RID'
	public static systemFields = [
		'RecordID',
	]

	public getPrimaryKey(): PrimaryKey {
		return this.RID!
	}

	CostingBind?: number
	ImplementationDate?: Date
	InternalText?: string
	BusinessText?: string
	EstimatedPrice?: number
	CostPrice?: number
	ListPrice?: number
	OfferedPrice?: number
	MeasureUnitId?: number
	Quantity?: number
	ArticleName?: string
	SequenceNumber?: number
	ItemTypeId?: number
	RID?: number
	RecordMod?: number
	RecordES?: number
	RecordID?: number
	RecordState?: number
	SelectionImgCalc?: string
	LegislationContextCalc?: number
	CurrentDateCalc?: Date
	CurrentTimeCalc?: Date
	QuantityUMCalc?: number
	CurrencyCalc?: string
	ExchangeRateCalc?: number
	DiscountCalc?: number
	UnitDiscountCalc?: number
	TotalDiscountCalc?: number
	DiscountCCalc?: number
	TotalDiscountCCalc?: number
	ProfitCalc?: number
	UnitProfitCalc?: number
	TotalProfitCalc?: number
	ProfitCCalc?: number
	TotalProfitCCalc?: number
	EstimatedUnitPriceCalc?: number
	EstimatedTotalPriceCalc?: number
	EstimatedPriceCCalc?: number
	EstimatedTotalPriceCCalc?: number
	CatalogUnitPriceCalc?: number
	CatalogTotalPriceCalc?: number
	CatalogUnitPriceCCalc?: number
	CatalogTotalPriceCCalc?: number
	OfferedUnitPriceNetCalc?: number
	OfferedTotalPriceNetCalc?: number
	OfferedUnitPriceNetCCalc?: number
	OfferedTotalPriceNetCCalc?: number
	UnitCostPriceCalc?: number
	TotalCostPriceCalc?: number
	CostPriceCCalc?: number
	TotalCostPriceCCalc?: number
	MeasureUnitCalc?: string
	MeasureUnitCoefficientCalc?: number
	RequiredItemNameCalc?: string
	ArticleNameCalc?: string
	UseForDocumentTotalAmountBitCalc?: number
	DiscountPctCalc?: number
	OfferedUnitPriceGrossCalc?: number
	OfferedTotalPriceGrossCalc?: number
	OfferedUnitPriceGrossCCalc?: number
	OfferedTotalPriceGrossCCalc?: number
	MainCurrencyCalc?: string
	CoefficientVATCalc?: number
	ImplementationDateCalc?: Date
	NotContainsArticleCalc?: string
	ProfitPctCalc?: number
	PriceGroup1ImgCalc?: number
	PriceGroup2ImgCalc?: number
	Deal1ImgCalc?: string
	Deal2ImgCalc?: string
	ArticleTypeIdCalc?: number
	@Type(() => TCode6DocumentDM)
	Code6Id?: TCode6DocumentDM
	@Type(() => TCode5DocumentDM)
	Code5Id?: TCode5DocumentDM
	@Type(() => TCode4DocumentDM)
	Code4Id?: TCode4DocumentDM
	@Type(() => TCode3DocumentDM)
	Code3Id?: TCode3DocumentDM
	@Type(() => WarrantyB)
	WarrantyId?: WarrantyB
	@Type(() => TBatchDM)
	BatchId?: TBatchDM
	@Type(() => TRequestedBatchParameterHeaderDM)
	RequestedBatchParametersId?: TRequestedBatchParameterHeaderDM
	@Type(() => TDeviceDocumentDM)
	DeviceRID?: TDeviceDocumentDM
	@Type(() => TPriceGroupDM)
	PriceGroupId?: TPriceGroupDM
	@Type(() => TRoutingVariantDM)
	RoutingVariantId?: TRoutingVariantDM
	@Type(() => TMarketingPhaseDM)
	PhaseRID?: TMarketingPhaseDM
	@Type(() => TVATRateDM)
	VATRateId?: TVATRateDM
	@Type(() => TArticleCodeDocumentDM)
	ArticleCodeId?: TArticleCodeDocumentDM
	@Type(() => TOfficerDocumentDM)
	OfficerId?: TOfficerDocumentDM
	@Type(() => TCode2DocumentDM)
	Code2Id?: TCode2DocumentDM
	@Type(() => TCode1DocumentDM)
	Code1Id?: TCode1DocumentDM
	@Type(() => TContractCodeDocumentDM)
	ContractCodeRID?: TContractCodeDocumentDM
	@Type(() => TCostCentreCollectionDocumentDM)
	CostCentreId?: TCostCentreCollectionDocumentDM
	@Type(() => TQuotationRequestedItemDM)
	RequiredItemRID?: TQuotationRequestedItemDM
	@Type(() => QuotationOfrItemStat)
	ItemStatusId?: QuotationOfrItemStat
	@Type(() => TArticleDM)
	ArticleId?: TArticleDM
	@Type(() => MrktngDocItemGroup)
	GroupId?: MrktngDocItemGroup
	@Type(() => TQuotationDM)
	HeaderRID?: TQuotationDM
	@Type(() => TMeasureUnitDM)
	MeasureUnitByArticleIdCalc?: TMeasureUnitDM
	@Type(() => AlternativeUnit)
	GeneralMueasureUnitIdCalc?: AlternativeUnit
	@Type(() => TArticleDM)
	ArticleByIdInputIdCalc?: TArticleDM
	@Type(() => TArticleDM)
	ArticleByAbbr2InputIdCalc?: TArticleDM
	@Type(() => TArticleDM)
	ArticleByNameInputIdCalc?: TArticleDM
	@Type(() => TReqForQuoRequestedItemAloneDM)
	ReqForQuotRequestedItemChild?: TReqForQuoRequestedItemAloneDM[]
	@Type(() => TReqForQuoOfferedItemAloneDM)
	ReqForQuotOfferedItemChild?: TReqForQuoOfferedItemAloneDM[]
	@Type(() => TPriceListCalculationDM)
	PriceCalculationChild?: TPriceListCalculationDM[]
	@Type(() => TProductCostingDM)
	ProductCostingChild?: TProductCostingDM[]
}